.header {
    width: 100%;
}

.identity {
    min-width: 0;
}

.text {
    min-width: 0;
}

.name {
    font-weight: 700;
}

.wrapper {
    position: relative;
    width: 72px;
    height: 72px;
    flex-shrink: 0;
}

.avatar {
    width: 72px;
    height: 72px;
}

.editButton {
    position: absolute;
    right: -4px;
    bottom: -4px;
    background-color: var(--mui-palette-background-paper, #fff);
    border: 1px solid var(--mui-palette-divider, rgba(0, 0, 0, 0.12));
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.editButton:hover {
    background-color: var(--mui-palette-action-hover, rgba(0, 0, 0, 0.04));
}

@media (max-width: 768px) {
    .wrapper {
        width: 48px;
        height: 48px;
    }

    .avatar {
        width: 48px;
        height: 48px;
    }
}
